import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Footer from './Footer.js';
import { CircleUserRound, FileText, LockKeyhole, FileSymlink, FileChartColumn, ReceiptText, ChevronRight, TabletSmartphone, Power } from 'lucide-react';

function Account() {
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [clients, setClients] = useState([]);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const encodedData = localStorage.getItem('user_data');
    const decodedData = atob(encodedData);
    const userData = JSON.parse(decodedData);

    if (userData && userData.client && Array.isArray(userData.client)) {

      setClients(userData.client[0]);
      setUserData(userData);

    } else {
      console.log("No clients found or data is not in expected format.");
    }
  }, []);

  if (!userData) {
    return <div>Loading...</div>;
  }

  // Extract the first letter of first_name and last_name, and combine them
  const initials = (clients.first_name?.charAt(0).toUpperCase() || '') + (clients.last_name?.charAt(0).toUpperCase() || '');

  const menuItems = [
    { label: "Profile", icon: <CircleUserRound className="w-5 h-5 mt-0" />, route: "/profile" },
    // { label: "Transaction History", icon: <FileText className="w-5 h-5 mt-0" />, route: "/account-transaction" },
    { label: "Change Password", icon: <LockKeyhole className="w-5 h-5 mt-0" />, route: "/account-change-password" },
    { label: "Rejection Logs", icon: <FileSymlink className="w-5 h-5 mt-0" />, route: "/account-rejection-logs" },
    { label: "Ledger Master", icon: <FileChartColumn className="w-5 h-5 mt-0" />, route: "/account-ledger-master" },
    { label: "Bill History", icon: <ReceiptText className="w-5 h-5 mt-0" />, route: "/bill-history" },
    { label: "Subscription", icon: <FileText className="w-5 h-5 mt-0" />, route: "/plans" },
    {
      label: "WhatsApp Support",
      icon: <TabletSmartphone className="w-5 h-5 mt-0" />,
      route: () => window.open("https://api.whatsapp.com/send/?text=Check+this+out%21+https%3A%2F%2Fexample.com&type=link&app_absent=0", "_blank")
    },
  ];

  const logOut = async () => {
    try {
      setIsLoggingOut(true);

      await logOut();
      localStorage.clear();
      navigate('/login');
    } catch (error) {
      console.error("Logout error:", error.response?.data || error.message);
    }
  };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[370px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        <h2 className="text-sm font-lato font-semibold text-gray-800 mb-4">Account</h2>

        <div className="relative flex flex-col items-center mb-6 bg-gray-100 pt-12 pb-6 rounded-lg">
          {/* Circle Avatar */}
          <div className="absolute -top-10 bg-pink-100 text-red-800 rounded-full w-20 h-20 flex items-center justify-center shadow-md">
            <span className="text-xl font-lato font-semibold">{initials}</span>
          </div>

          {/* User Info */}
          <h3 className="mt-4 text-sm font-lato font-bold">{clients.first_name} {clients.last_name}</h3>
          <p className="text-xs font-lato text-gray-600">I.D: {clients.client_username}</p>
        </div>

        <div className="space-y-2">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={typeof item.route === 'function' ? item.route : () => navigate(item.route)}
              className="w-full flex items-center justify-between px-4 py-6 bg-gray-100 hover:bg-gray-200 rounded-md text-left"
            >
              <div className="flex items-center gap-2">
                <span className="me-2">{item.icon}</span>
                <span className="text-sm font-lato font-medium">{item.label}</span>
              </div>
              <span className="text-gray-700 font-bold"><ChevronRight size={14} /></span>
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <button
          className="flex items-center justify-center mt-6 bg-[#536895] w-full border border-[#536895] rounded-lg text-white text-base font-semibold py-3 disabled:opacity-70"
          onClick={logOut}
          disabled={isLoggingOut}
        >
          {isLoggingOut ? (
            <span className="animate-pulse">Logging out...</span>
          ) : (
            <>
              <Power size={20} className="mr-2" />
              Logout
            </>
          )}
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default Account;